import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Popover, MenuItem, MenuList, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useSystem } from '../contexts/SystemContext';

interface Props {
  variant?: 'light' | 'dark';
}

const LanguageSwitcher: React.FC<Props> = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();
  const { availableLanguages } = useSystem();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (availableLanguages.length <= 1) return null;

  const currentLang = availableLanguages.find(l => l.code === i18n.language);
  const isLight = variant === 'light';

  return (
    <>
      <Tooltip title={currentLang?.ename ?? i18n.language}>
        <IconButton
          onClick={e => setAnchor(e.currentTarget)}
          size="small"
          sx={isLight
            ? { color: 'rgba(255,255,255,0.85)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.12)' } }
            : { color: '#5b6abf', '&:hover': { color: '#4a57a8', bgcolor: 'rgba(102,126,234,0.1)' } }
          }
        >
          <LanguageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList dense sx={{ minWidth: 140 }}>
          {availableLanguages.map(lang => (
            <MenuItem
              key={lang.code}
              selected={i18n.language === lang.code}
              onClick={() => { i18n.changeLanguage(lang.code); setAnchor(null); }}
            >
              {lang.short_name || lang.code}&nbsp;&nbsp;{lang.ename}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};

export default LanguageSwitcher;
